import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Table from 'rc-table';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../../components/BaseComponent';
import { CompanyWorkflowActionsContainer } from './CompanyWorkflowActionsContainer';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyWorkflowsOverviewTableComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  get workflows() {
    return this.props.workflows;
  }

  getData = workflow => {
    return {
      id: workflow.id,
      name: workflow.name,
      actions: workflow,
      company_id: this.props.company_id,
    };
  };

  getColumns = () => {
    return [
      { title: this.lblStr('workflows.column.name'), dataIndex: 'name', key: 'name', align: 'left' },
      {
        key: 'actions',
        dataIndex: 'actions',
        render(value, row, index) {
          return <CompanyWorkflowActionsContainer workflow={value} company_id={row.company_id} />;
        },
      },
    ];
  };

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  // onClickDeleteBtn() {
  //   this.setState({ removeWorkflowConfirmation: true });
  // }

  render() {
    const columns = this.getColumns();
    const data = this.workflows?.map(w => this.getData(w));

    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={'No workflows allowed for the company'}
          onRow={(record, index) => ({
            onClick: () => {
              return this.to(`/company-workflows/${record.company_id}/workflows/${record.id}`);
            },
          })}
        />
      </Container>
    );
  }
}

CompanyWorkflowsOverviewTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyWorkflowsOverviewTable = compose(withConnect, withRouter, injectIntl)(CompanyWorkflowsOverviewTableComp);
